import React from "react";
import { Box, Button, Divider, Typography, useMediaQuery } from "@mui/material";

const ProductCard = ({ item, onBuy }) => {
  const isMobile = useMediaQuery("(max-width: 599.95px)");

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: isMobile ? "14px" : "14px",
        background: "#FFFFFF",
        boxShadow: isMobile ? "0px 7.194px 18.705px 0px rgba(0,0,0,0.04)" : "0px 8.201px 21.323px 0px rgba(0,0,0,0.04)",
        p: isMobile ? "14px" : "16px",
      }}
    >
      <Box sx={{ position: "relative", mb: isMobile ? "14px" : "16px" }}>
        <Box
          component="img"
          src={item.image}
          alt={item.title}
          sx={{
            width: "100%",
            height: isMobile ? "145px" : "140.239px",
            borderRadius: isMobile ? "10px" : "14px",
            objectFit: "cover",
            display: "block",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            right: isMobile ? "auto" : "12px",
            left: isMobile ? "134px" : "auto",
            top: isMobile ? "105px" : "auto",
            bottom: isMobile ? "auto" : "10px",
            px: isMobile ? "12px" : "14.538px",
            py: isMobile ? "6px" : "6.23px",
            borderRadius: isMobile ? "4px" : "6.23px",
            background: "#A9C74E",
            minHeight: isMobile ? "28px" : "29px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: isMobile ? "10px" : "12px", lineHeight: isMobile ? "16px" : "16.615px", letterSpacing: "-0.2px", color: "#FFFFFF", whiteSpace: "nowrap" }}>
            {item.tagField || "Feeds 50+ Children"}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: isMobile ? "8px" : "11.482px", mb: isMobile ? "12px" : "16.402px", minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: isMobile ? "14px" : "16px", lineHeight: isMobile ? "16.8px" : 1.2, color: "#1D1D1B", textTransform: "capitalize" }}>
          {item.title}
        </Typography>
        <Typography
          title={typeof item.description === "string" ? item.description : undefined}
          sx={{
            fontWeight: 500,
            fontSize: isMobile ? "12px" : "14px",
            lineHeight: isMobile ? "19.416px" : "25.888px",
            color: "#686866",
            textTransform: "capitalize",
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            wordBreak: "break-word",
          }}
        >
          {item.description}
        </Typography>
      </Box>

      <Divider sx={{ borderColor: "#E8E8E8", mb: isMobile ? "14px" : "16.402px" }} />

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
        <Box sx={{ display: "flex", alignItems: "end", gap: "6px" }}>
          <Typography sx={{ fontWeight: 700, fontSize: isMobile ? "18px" : "16px", lineHeight: isMobile ? "12.95px" : "14.762px", letterSpacing: isMobile ? "-0.36px" : "-0.32px", color: "#1D1D1B" }}>
            ₹{item.price}
          </Typography>
          <Typography sx={{ fontWeight: 700, fontSize: isMobile ? "18px" : "16.615px", lineHeight: "14.762px", color: "#1D1D1B" }}>/</Typography>
          <Typography sx={{ fontWeight: 500, fontSize: isMobile ? "12px" : "12px", lineHeight: 1, color: "#686866", textTransform: "capitalize" }}>
            {item.quantity ? `${item.quantity}` : "pack"}
          </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={onBuy}
          sx={{
            width: isMobile ? "115.108px" : "123px",
            minWidth: isMobile ? "115.108px" : "123px",
            height: isMobile ? "39px" : "40px",
            borderRadius: isMobile ? "7.194px" : "7.614px",
            background: "#F04951",
            boxShadow: isMobile ? "0px 2.878px 0px 0px #141414" : "0px 3.046px 0px 0px #141414",
            textTransform: "none",
            fontWeight: 700,
            fontSize: isMobile ? "10px" : "14px",
            lineHeight: isMobile ? "10.072px" : "10.66px",
            color: "#FFFFFF",
            "&:hover": { background: "#F04951" },
          }}
        >
          Buy Now
        </Button>
      </Box>
    </Box>
  );
};

export default ProductCard;
